import { IS_DEVELOPMENT } from '@constants/globals'

export const stubFetch =
  (cb: (payload?: string) => void) => async (_url: RequestInfo, config: RequestInit) => {
    const { body } = config

    cb(body?.toString())

    return {
      ok: true,
      status: 200,
      async json() {
        return {}
      },
      arrayBuffer(): Promise<ArrayBuffer> {
        throw new Error('Not Implemented')
      },
      blob(): Promise<Blob> {
        throw new Error('Not Implemented')
      },
      clone(): Response {
        throw new Error('Not Implemented')
      },
      text(): Promise<string> {
        throw new Error('Not Implemented')
      },
    } as Response
  }

export async function beacon(url: RequestInfo, config: RequestInit) {
  navigator.sendBeacon(url as string, config.body)

  return {
    ok: true,
    status: 200,
    async json() {
      return {}
    },
    arrayBuffer(): Promise<ArrayBuffer> {
      throw new Error('Not Implemented')
    },
    blob(): Promise<Blob> {
      throw new Error('Not Implemented')
    },
    clone(): Response {
      throw new Error('Not Implemented')
    },
    text(): Promise<string> {
      throw new Error('Not Implemented')
    },
  } as Response
}

// This client-side guard allows automatically sending batched events that haven't been sent yet when the tab is switched or closed
export function unloadGuard() {
  // eslint-disable-next-line unicorn/consistent-function-scoping
  let callback = () => {
    /* */
  }

  // More details why we need both: https://xgwang.me/posts/you-may-not-know-beacon/#the-confusion
  window.addEventListener('beforeunload', () => {
    callback()
  })
  window.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') {
      callback()
    }
  })

  return (_cb: () => void) => {
    callback = _cb
  }
}

export const getFetchImpl = () => {
  if (IS_DEVELOPMENT) {
    return stubFetch(payload =>
      console.info(`FeMetrics call intercepted in dev mode with payload: ${payload}`),
    )
  }

  return 'sendBeacon' in navigator ? beacon : fetch.bind(window)
}
